var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { NumberFormat } from './number';
import { language } from '@comall-backend-builder/core/lib/services';

var NumberPositiveFormat = function (_super) {
  __extends(NumberPositiveFormat, _super);

  function NumberPositiveFormat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 对数据进行校验
   */


  NumberPositiveFormat.prototype.validate = function (_rule, value, callback) {
    if (value && !/^[0-9]+\.?[0-9]*$/.test(value)) {
      callback(language.getText('validation.number.positive'));
    } else {
      callback();
    }
  };
  /**
   * 将数据格式化为 positive number 类型的值
   */


  NumberPositiveFormat.prototype.format = function (value) {
    if (typeof value !== 'number') {
      value = parseFloat(value);
    } // NaN, +Infinity, -Infinity


    if (Number.isFinite(value) === false) {
      value = undefined;
    } else {
      value = Math.abs(value);
    }

    return value;
  };

  return NumberPositiveFormat;
}(NumberFormat);

export { NumberPositiveFormat };